export class SurchargeTranslation {
  constructor(
    public locale: string,
    public name: string,
    public externalDescription: string,
  ) {}
}
